interface FilterBarProps {
  subCategories: string[];
  activeSub: string;
  onSubChange: (sub: string) => void;
  sort: 'desc' | 'asc';
  onSortChange: (sort: 'desc' | 'asc') => void;
}

export default function FilterBar({
  subCategories,
  activeSub,
  onSubChange,
  sort,
  onSortChange,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-3 md:p-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="hidden flex-wrap items-center gap-2 md:flex">
          <span className="text-xs text-secondary-500">子分类：</span>
          {subCategories.map((sub) => (
            <button
              key={sub}
              type="button"
              onClick={() => onSubChange(sub)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                activeSub === sub
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              {sub}
            </button>
          ))}
        </div>

        <div className="md:hidden">
          <label className="mb-1 block text-xs text-secondary-500">选择子分类</label>
          <select
            value={activeSub}
            onChange={(e) => onSubChange(e.target.value)}
            className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 outline-none focus:border-primary-400"
          >
            {subCategories.map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-2">
          <span className="hidden text-xs text-secondary-500 sm:inline">排序：</span>
          <div className="flex items-center rounded-full bg-background-100 p-1">
            <button
              type="button"
              onClick={() => onSortChange('desc')}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                sort === 'desc' ? 'bg-background-50 text-primary-600' : 'text-secondary-600'
              }`}
            >
              最新发布
            </button>
            <button
              type="button"
              onClick={() => onSortChange('asc')}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                sort === 'asc' ? 'bg-background-50 text-primary-600' : 'text-secondary-600'
              }`}
            >
              最早发布
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}